import axios from "axios";


  const SendOperatorTreatmentResponseEvent =  async (cartId,eventType,eventSubtype, eventName,operation,parameters="",releventUrl) => {

    try {
      const response = await axios.post(`${releventUrl}/admin/operator_treatment_response_event`, {
        type:eventType,
        subtype: eventSubtype,
        eventName,
        operation,
        parameters,
        cart_id: cartId,
      });
      return response.data;
    } catch (error) {
      console.error("Error sending operator treatment response:", error);
      throw error;
    }
  }

export default SendOperatorTreatmentResponseEvent;
